import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const NotFoundPage = () => {
    const navigate = useNavigate();
    const { language } = useLanguage();
    const isZh = language === 'zh';

    return (
        <div style={styles.container}>
            <div style={styles.code}>404</div>
            <h1 style={styles.title}>
                {isZh ? '页面未找到' : 'Page Not Found'}
            </h1>
            <p style={styles.message}>
                {isZh
                    ? '抱歉，您访问的页面不存在或已被移除'
                    : "Sorry, the page you're looking for doesn't exist or has been moved."}
            </p>
            <div style={styles.actions}>
                <button
                    onClick={() => navigate('/')}
                    style={styles.primaryButton}
                    aria-label={isZh ? '返回首页' : 'Go to homepage'}
                >
                    {isZh ? '返回首页' : 'Go Home'}
                </button>
                <button
                    onClick={() => navigate(-1)}
                    style={styles.secondaryButton}
                    aria-label={isZh ? '返回上一页' : 'Go back'}
                >
                    {isZh ? '返回上一页' : 'Go Back'}
                </button>
            </div>
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: '2rem',
        textAlign: 'center',
    },
    code: {
        fontSize: '6rem',
        fontWeight: '800',
        color: '#E5E5EA',
        letterSpacing: '-0.04em',
        marginBottom: '0.5rem',
    },
    title: {
        fontSize: '1.75rem',
        fontWeight: '700',
        color: '#1D1D1F',
        marginBottom: '0.75rem',
    },
    message: {
        fontSize: '1rem',
        color: '#86868B',
        marginBottom: '2rem',
        maxWidth: '400px',
        lineHeight: '1.5',
    },
    actions: {
        display: 'flex',
        gap: '12px',
    },
    primaryButton: {
        padding: '12px 28px',
        backgroundColor: '#007AFF',
        color: '#fff',
        border: 'none',
        borderRadius: '12px',
        fontSize: '1rem',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'transform 0.15s ease',
    },
    secondaryButton: {
        padding: '12px 28px',
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
        color: '#1D1D1F',
        border: '1px solid rgba(0, 0, 0, 0.08)',
        borderRadius: '12px',
        fontSize: '1rem',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'background-color 0.15s ease',
    },
};

export default NotFoundPage;
